import { Link } from "react-router-dom";
import { Reveal } from "./Reveal";

export const SpeakingCTA = () => (
  <section className="px-6 sm:px-12 lg:px-20 pb-24 sm:pb-32 max-w-7xl mx-auto" data-testid="speaking-cta">
    <Reveal>
      <div className="border border-blue-100/15 p-8 sm:p-14 grid lg:grid-cols-12 gap-8 items-center">
        <div className="lg:col-span-8">
          <p className="font-meta text-[10px] sm:text-xs tracking-[0.3em] text-blue-300/60 mb-5">
            NOW BOOKING — SPEAKING
          </p>
          <p className="font-display font-extrabold uppercase tracking-tighter leading-[0.98] text-[clamp(1.8rem,4.5vw,3.6rem)]">
            Don't just react to life. <span className="text-aura-gradient">Create a life.</span>
          </p>
          <p className="text-sm sm:text-base font-light text-blue-100/60 mt-5 max-w-2xl">
            Jeremiah is a 16-year-old speaker available for schools, youth programs, community
            organizations, conferences, churches, and events — in person or virtual.
          </p>
        </div>
        <div className="lg:col-span-4 flex flex-col gap-3 lg:items-end">
          <Link
            to="/book"
            data-testid="cta-book-link"
            className="w-full lg:w-auto font-meta text-xs tracking-[0.25em] bg-[#4F7CFF] text-white rounded-full px-8 py-3.5 hover:bg-white hover:text-black transition-colors duration-300 text-center"
          >
            BOOK JEREMIAH
          </Link>
          <Link
            to="/speaking"
            data-testid="cta-speaking-link"
            className="w-full lg:w-auto font-meta text-xs tracking-[0.25em] border border-blue-200/30 rounded-full px-8 py-3.5 hover:bg-[#4F7CFF] hover:border-[#4F7CFF] transition-colors duration-300 text-center"
          >
            THE SPEAKING PAGE →
          </Link>
        </div>
      </div>
    </Reveal>
  </section>
);
